import React from 'react';

import {Asterisk} from '../index';

export const RequiredLabel = ({label}: {label: string}) => (
  <>
    {label}
    <Asterisk />
  </>
);
